var Mousetrap = require('mousetrap');

/**
 * Mousetrap.stopCallback is a method that is called to see if the keyboard event
 * should fire based on if you are inside a form input field.
 * If true is returned then it stops the callback from firing, if false it fires it.
 * As of version 1.5+, must put on the prototype:
 * https://stackoverflow.com/questions/21013866/mousetrap-bind-is-not-working-when-field-is-in-focus
 */

Mousetrap.prototype.stopCallback = function(e, element, combo) {

    var elementsNotAllowed =
            (element.tagName === 'INPUT' || element.tagName === 'SELECT' ||
                element.tagName === 'TEXTAREA' || (element.contentEditable && element.contentEditable === 'true')),

        keysAllowed = (combo !== 'esc')
            && (combo !=='shift+enter')
            && (combo !=='up')
            && (combo !=='down')
            && (combo !=='right')
            && (combo !=='left')
        ;

    return elementsNotAllowed && keysAllowed;

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/extension/mousetrap.js
 ** module id = 67
 ** module chunks = 0
 **/